// extracted by mini-css-extract-plugin
export default {"container":"_3Atn1","amount":"_2sxvu","tooltip":"_3OXa3","tooltipIcon":"_3-1CN"};